/* Journal: reading-time estimate for section-built articles, share (native + copy link). */
(() => {
  if (window.__harberBlog) return;
  window.__harberBlog = true;

  // Reading time: articles whose body lives in article-text sections have no article.content,
  // so the server leaves [data-reading-time] hidden and we count the words on the page.
  const rt = document.querySelector('[data-reading-time][hidden]');
  if (rt) {
    const text = [...document.querySelectorAll('[data-article-prose]')].map((el) => el.textContent).join(' ');
    const words = text.trim().split(/\s+/).filter(Boolean).length;
    if (words > 60) {
      const minutes = Math.max(1, Math.round(words / 225));
      rt.textContent = (rt.dataset.template || '[minutes] min').replace('[minutes]', minutes);
      rt.hidden = false;
      rt.previousElementSibling?.removeAttribute('hidden');
    }
  }

  document.querySelectorAll('[data-share]').forEach((root) => {
    const url = root.dataset.url || location.href;
    const title = root.dataset.title || document.title;
    const status = root.querySelector('[data-share-status]');
    const nativeItem = root.querySelector('[data-share-native-item]');

    if (navigator.share && nativeItem) {
      nativeItem.hidden = false;
      nativeItem.querySelector('[data-share-native]').addEventListener('click', () => {
        navigator.share({ title, url }).catch(() => {});
      });
    }

    const copy = root.querySelector('[data-share-copy]');
    copy?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
      } catch (e) {
        const input = Object.assign(document.createElement('input'), { value: url });
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      copy.classList.add('is-done');
      if (status) status.textContent = copy.dataset.copiedLabel || '';
      setTimeout(() => copy.classList.remove('is-done'), 1800);
    });
  });
})();
